import apiConfig from "../../../config/api";

export const setNombreEtapa = (etapa) => {
  switch (etapa) {
    case 0:
      return "Sensibilización";
    case 1:
      return "Diagnóstico";
    case 2:
      return "Plan de acción";
    case 3:
      return "Ejecución y seguimiento";
    default:
      return null;
  }
};

export const getSubMedidaPosition = (medidas, idplanSubMedida) => {
  let position = null;
  for (let i = 0; i < medidas.length; i++) {
    for (let j = 0; j < medidas[i].tblPlanSubMedida.length; j++) {
      if (medidas[i].tblPlanSubMedida[j].idplanSubMedida === idplanSubMedida) {
        position = `${i},${j}`;
        break;
      }
    }
  }
  return position;
};

// compara fechas con el día de hoy, 1 si es mayor, 0 si son iguales -1 si es menor
export const compareDateToday = (fecha) => {
  const today = new Date();
  const date = new Date(fecha);

  if (date.getFullYear() < today.getFullYear()) {
    return -1;
  } else if (date.getFullYear() === today.getFullYear()) {
    if (date.getMonth() < today.getMonth()) {
      return -1;
    } else if (date.getMonth() === today.getMonth()) {
      if (date.getDate() < today.getDate()) {
        return -1;
      } else if (date.getDate() === today.getDate()) {
        return 0;
      }
      return 1;
    }
    return 1;
  }
  return 1;
};

/*
* return:
* -1 : A es menor
* 0  : iguales
* 1  : A es mayor
*/
export const compareTwoDates = (inicio, limite) => {
  const start = new Date(inicio);
  const ends = new Date(limite);

  if (start.getFullYear() < ends.getFullYear()) {
    return -1;
  } else if (start.getFullYear() === ends.getFullYear()) {
    if (start.getMonth() < ends.getMonth()) {
      return -1;
    } else if (start.getMonth() === ends.getMonth()) {
      if (start.getDate() < ends.getDate()) {
        return -1;
      } else if (start.getDate() === ends.getDate()) {
        return 0;
      }
      return 1;
    }
    return 1;
  }
  return 1;
};

export const generaSubMedidasAprobadas = (medidas) => {
  let miniMedidas = [];
  let medidaAux = null;
  let subMedidasAux = null;
  for (let i = 0; i < medidas.length; i++) {
    medidaAux = medidas[i];
    subMedidasAux = medidaAux.tblPlanSubMedida.filter((sb) => sb.subMedidaElegida);
    miniMedidas = miniMedidas.concat(Object.assign({}, medidaAux, { tblPlanSubMedida: subMedidasAux }));
  }
  return miniMedidas;
};

export const getTareasAprobada = (tareas) => {
  let tareasSeleccionadas = [];
  for (let i = 0; i < tareas.length; i++) {
    if (tareas[i].completada) {
      tareasSeleccionadas = tareasSeleccionadas.concat(tareas[i]);
    }
  }
  return tareasSeleccionadas;
};

export const aprobarTareas = (tareas) => {
  let nuevaTareas = [];
  for (let i = 0; i < tareas.length; i++) {
    nuevaTareas = nuevaTareas.concat(Object.assign({}, tareas[i], { completada: true }));
  }
  return nuevaTareas;
};

export const desaprobarTareas = (tareas) => {
  let nuevaTareas = [];
  for (let i = 0; i < tareas.length; i++) {
    nuevaTareas = nuevaTareas.concat(Object.assign({}, tareas[i], { completada: false }));
  }
  return nuevaTareas;
};

export const restoTareas = (todas, aprobadas) => {
  let restoTareas = todas;
  for (let i = 0; i < todas.length; i++) {
    for (let j = 0; j < aprobadas.length; j++) {
      if (todas[i].idplanSubMedidaTarea === aprobadas[j].idplanSubMedidaTarea) {
        restoTareas = restoTareas.filter((t) => t.idplanSubMedidaTarea);
      }
    }
  }
  return desaprobarTareas(restoTareas);
};

export const dateFormat = (fechaIn) => {
  const fechaOut = new Date(fechaIn);
  return `${fechaOut.getDate()}/${fechaOut.getMonth() + 1}/${fechaOut.getFullYear()}`;
};

export const filtroPrevencionista = (employees) => {
  // por alguna razón el nombre del prevencionista cambia en producción y dev.
  let rolPrevencionista = '';
  switch(process.env.NODE_ENV){
    case 'development':
    case 'production':
    default:
      rolPrevencionista = 'Prevención';
      break;
  }
  let PrevencionistasList= []
  // reviso cada empleado
  for (let i in employees){
    const { Roles } = employees[i];
    // reviso sus roles
    for (let j in Roles){
      const {Name} = Roles[j];
      if (Name === rolPrevencionista) {
        PrevencionistasList.push(employees[i]);
        break;
      }
    }
  }
  return PrevencionistasList;
}

export const getNombreEncargado = (prevencionistas, rutFinder) => {
  for (let i=0; i<prevencionistas.length; i++){
    if (prevencionistas[i].Rut === rutFinder) {
      return {nombre: prevencionistas[i].EmployeeName, email: prevencionistas[i].Email};
    }
  }
  return {nombre: "", email: ""};
}


export const getDocumentoEstadisticas = (idplanMovilidad) => {
  window.open(`${apiConfig.linkEncuestasMovilidad}/documento/${idplanMovilidad}`, "_blank");
}

export const nombrePlanMovilidad = (fecha,idcentro) => {
  const fechaOut = new Date(fecha);
  return `PlanMovilidad-CT${idcentro}-${fechaOut.getDate()}${fechaOut.getMonth() + 1}${fechaOut.getFullYear()}`;
}

export const scrollElementToTop = (elementName) => {
  //let div = document.getElementById(elementName);
  //div.scrollIntoView();
}

export const dataLayerTag = (event) => {
  window.dataLayer.push(event);
}

// porcentajes para la encuestas de trabajadores
export const porcentajesEncuestasTrabajadores = (cantidad, total) => {
  var porcentaje = 0;
  if (total === 0 || cantidad === 0) {
    return 0;
  }
  porcentaje = (parseInt(cantidad) / parseInt(total)) * 100;
  return Math.round(porcentaje, -1);
}
